/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

const LEASE_TEMPLATE_BASE_LINK = '/admin/leases/templates'

export function getLeaseTemplateCreateLink () {
  return `${LEASE_TEMPLATE_BASE_LINK}`
}

export function getLeaseTemplateLink (id: number) {
  return `${LEASE_TEMPLATE_BASE_LINK}/${id}/edit`
}

export function getLeaseTemplateListLink () {
  return LEASE_TEMPLATE_BASE_LINK
}
